import React, {Component} from 'react'
import Styles from './UserPage.module.css'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import DateUtilities from '../../componentes/DateUtilities'
import {Dropdown, Input} from 'semantic-ui-react'
import moment from 'moment'
import WeekPayment from './WeekPayment'

export default class PagosAdmin extends Component{
    constructor(props){
        super(props)
        this.state={
            pagos:[],
            dateFilter:'all',
            employee:this.props.userName || 'No nombre',
            fechaFiltro:new Date("2021-10-13 00:00:23"),
        }
        this.unsubscribe=null
    }
    
    setReference=()=>{
        let dbReference=firebase.firestore().collection('Pagos')
        dbReference=this.filterByEmployee(dbReference)
        dbReference=this.filterByDate(dbReference)
        return dbReference
    }
    filterByDate=(dbReference)=>{
        return dbReference.where('fecha', '>=', this.state.fechaFiltro)
    }
    filterByEmployee=dbReference=>{
        if(this.state.employee==='' || this.state.employee==='all') return dbReference
        return dbReference.where('empleado', '==', this.state.employee)
    }
    getWeekAndYear=(date)=>{
        let momentDate=moment(date)
        let dayOfTheWeek=momentDate.day()
        let year=momentDate.year()
        let week=dayOfTheWeek>=4 
            ? moment(DateUtilities.addDays(date, 3)).week()
            : momentDate.week() 
        return`${week} ${year}`
    }
    GetData=()=>{
		this.unsubscribe=this.setReference().orderBy('fecha','desc').onSnapshot(pagos=>{
            try{
                const pagosArray=[]
                let weekIndex=-1
                let empleadosIndexMap={}
                for(let i=0; i<pagos.size;i++){
                    const pago=pagos.docs[i]
                    const date=pagos.docs[i].data().fecha.toDate()
                    const weekAndYear=this.getWeekAndYear(date)
                    if(pagosArray.length===0 || pagosArray[weekIndex].weekAndYear!==weekAndYear){
                        pagosArray.push({weekAndYear:weekAndYear, employees:[], total:0})
                        weekIndex++
                        empleadosIndexMap={}
                    }
                    const employee=pago.data().empleado
                    if(empleadosIndexMap[employee]===undefined){
                        pagosArray[weekIndex].employees.push({
                            employee:employee,
                            salary:0,
                            activitiesDestajo:[],
                            activitiesDia:[],
                            harvestFrambuesa:[],
                            harvestZarzamora:[],
                        })
                        empleadosIndexMap[employee]=pagosArray[weekIndex].employees.length-1   
                    }
                    pagosArray[weekIndex].employees[empleadosIndexMap[employee]].salary+=pago.data().precio
                    pagosArray[weekIndex].total+=pago.data().precio

                    if(pago.data().nombreActividad==='Piscar Zarzamora'){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].harvestZarzamora.push({
                            id:pago.id,
                            actividad:pago.data().nombreActividad,
                            areaHecha:pago.data().areaHecha,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            precio:pago.data().precio,
                            cajas6Precio:pago.data().cajas6Precio,
                            dificultad:pago.data().dificultad,
                            totalCajas:pago.data().totalCajas,
                        })
                    }else if(pago.data().nombreActividad==='Piscar Frambuesa'){
                            pagosArray[weekIndex].employees[empleadosIndexMap[employee]].harvestFrambuesa.push({
                                id:pago.id,
                                actividad:pago.data().nombreActividad,
                                areaHecha:pago.data().areaHecha,
                                fecha:pago.data().fecha.toDate().toLocaleDateString(),
                                estado:pago.data().estado,
                                precio:pago.data().precio,
                                cajas6Precio:pago.data().precio / pago.data().trabajoHecho,
                                dificultad:pago.data().dificultad,
                                trabajoHecho:pago.data().trabajoHecho,
                            })
                        }else if(pago.data().precio===0){
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].activitiesDia.push({
                            id:pago.id,
                            actividad:pago.data().nombreActividad,
                            descripcion:pago.data().descripcion,
                            areaHecha:pago.data().areaHecha,
                            trabajoHecho:pago.data().trabajoHecho,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            unidades:pago.data().unidades,
                            numInvolucrados:pago.data().numInvolucrados,
                            precio:pago.data().precio,
                            dificultad:pago.data().dificultad,
                        })
                    }else{
                        pagosArray[weekIndex].employees[empleadosIndexMap[employee]].activitiesDestajo.push({
                            id:pago.id,
                            actividad:pago.data().nombreActividad,
                            descripcion:pago.data().descripcion,
                            areaHecha:pago.data().areaHecha,
                            trabajoHecho:pago.data().trabajoHecho,
                            fecha:pago.data().fecha.toDate().toLocaleDateString(),
                            estado:pago.data().estado,
                            unidades:pago.data().unidades,
                            numInvolucrados:pago.data().numInvolucrados,
                            precio:pago.data().precio,
                            dificultad:pago.data().dificultad,
                        })
                    }
                }
                this.setState({
                    pagos:pagosArray
                })
            }
            catch(e){
                console.log(e)
            }
        })
    }
    handleDateFilterChange=(e, {value})=>{
        this.setState({dateFilter:value})
    }
    handleSpecificDateChange=(e, {name, value})=>{
        const date=DateUtilities.parseDate(value)
        this.setState({
            [name]:date,
            [name+'Str']:value
        })
    }
    componentDidMount(){
        this.GetData()
    }
    componentDidUpdate(prevProps, prevState){
        let filtersHaveChanged=false
        if(this.state.dateFilter!==prevState.dateFilter && this.state.dateFilter!=='specificDateRange'){
            filtersHaveChanged=true
        }
        if(this.state.employee!==prevState.employee)
            filtersHaveChanged=true
        if(this.state.firstDate!== prevState.firstDate && this.state.secondDate!=='')
            filtersHaveChanged=true
        if(this.state.secondDate!==prevState.secondDate && this.firstDate!=='')
            filtersHaveChanged=true
        if(filtersHaveChanged){
            this.unsubscribe()
            this.GetData()
        }
    }
    render(){
        return(
            <section className={Styles.pagos}>
                <h1>Historial de Actividades</h1>
                <div className={Styles.filtros}>
                    <div className={Styles.input} style={{display: "none"}}>
                        <h3>Filtrar por fecha:</h3>
                        <Dropdown
                            fluid
                            selection
                            options={[
                                {key:3, text:'Este mes', value:'thisMonth'},
                                {key:4, text:'Este año', value:'thisYear'},
                                {key:5, text:'Fechas específicas', value:'specificDateRange'},
                            ]}
                            name='dateFilter'
                            value={this.state.dateFilter}
                            onChange={this.handleDateFilterChange}
                        />
                    </div>
                    {
                        this.state.dateFilter==='specificDateRange'
                         ?
                        <>
                        <div className={Styles.input}>
                            <h3>Del</h3>
                            <Input
                                type='date'
                                value={this.state.firstDateStr}
                                name='firstDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        <div className={Styles.input}>
                            <h3>Al</h3>
                            <Input
                                type='date'
                                value={this.state.secondDateStr}
                                name='secondDate'
                                onChange={this.handleSpecificDateChange}
                            />
                        </div>
                        </>
                        :null
                    }
                </div>
                {
                    this.state.pagos.map((week, i)=>{
                        return <WeekPayment key={i} week={week}/>
                    })
                }
            </section>
        )
    }
}